angular.module('bmsApp.settings').factory('StripeConfigurationSvc', function ($http, $log, $window, $q, CRUDSvc, APP_SETTING_API) {

	return {
		index: function(params){return CRUDSvc.get(APP_SETTING_API.INDEX, params);},
		create: function (data) {return CRUDSvc.create(APP_SETTING_API.CREATE, data);},
		update: function (data) {return CRUDSvc.post(APP_SETTING_API.UPDATE, data);},
		sslTypes: function(){
			return [
				{id: '', label: 'None'},
				{id: 'ssl', label: 'SSL'}
			]
		}
	}

}).constant('APP_SETTING_API', {
	INDEX: 'api/settings/appSettings/index',
	CREATE: 'api/settings/appSettings/create',
	UPDATE: 'api/settings/appSettings/update'
});




